export default class GeoentityNotFoundError extends Error {
  constructor(e = 'That geoentity was not found') {
    super(e)
    this.name = 'GeoentityNotFoundError'
  }
}
